import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Mode } from 'company-finder-common';
import { DeploymentContext } from '../utilities/deployment-context/deployment-context.js';

@Injectable({ providedIn: 'root' })
export class ModeResolver {
	constructor(private context: DeploymentContext) {}

	public async resolve(route: ActivatedRouteSnapshot): Promise<Mode> {
		// If no mode is provided, fall back to the mode the user is already in
		let mode: Mode = route.queryParams['mode'] ?? this.context.currentMode;

		// Since the mode resolver is at the root level, we need to step down into the
		// child to have access to the data because that is where it is stored
		const supportedModesKey =
			route.firstChild?.data?.supportedModesKey || null;

		if (supportedModesKey) {
			// If the key from the app routing module is not configured, allow all enabled modes
			const supportedModes =
				this.context.perPageModes[supportedModesKey] ??
				this.context.enabledModes;

			// If the mode isn't supported for this page, select one that is
			if (!supportedModes.includes(mode)) {
				mode = supportedModes[0];
			}
		}

		// Only set the mode if it is enabled to prevent url manipulation
		// allowing access to disabled functionality
		if (this.context.enabledModes.includes(mode)) {
			this.context.currentMode = mode;
		}

		return this.context.currentMode;
	}
}
